import { SearchCommerciauxQueryParams } from '../../../components/pages/connected/Dashboard/DashboardCommerciaux/DashboardCommerciauxTable/DashboardCommerciauxTable.types';
import { AllCommercialRequestParams } from '../../../hooks/fetchers/useCommerciaux/useCommerciaux.types';
import { UseCommissionsByMonthQueryParams } from '../../../hooks/fetchers/useCommissionsByMonth/useCommissionsByMonth.types';
import { CreateCommercialRequestData } from '../../../types/api/endpoints/commercial/create.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const COMMERCIAL_ENDPOINTS = Object.freeze({
  create: (data: CreateCommercialRequestData) =>
    api.post(StaticPostEndpoints.CreateCommercial, data),
  update: (data: CreateCommercialRequestData) =>
    api.put(StaticPostEndpoints.UpdateCommercial, data),

  enable: (commercialId: number) => api.put(`commercial/enable`, { commercialId }),
  disable: (commercialId: number) => api.put(`commercial/disable`, { commercialId }),

  getOne: (commercialId: number) => api.get(`commercial/${commercialId}`),
  getOneEmail: (commercialId: number) => api.get(`commercial/${commercialId}/init`),
  getAll: (params: AllCommercialRequestParams) =>
    api.get(StaticGetEndpoints.AllCommerciaux, params),
  getAllList: () => api.get(StaticGetEndpoints.AllCommerciauxList),

  search: (search: string, params: SearchCommerciauxQueryParams) =>
    api.get(`commercial/search/dir/${search}`, params),

  getAllInvoices: () => api.get(StaticGetEndpoints.CurrentInvoices),
  uploadInvoice: (invoiceId: number, data: FormData) =>
    api.post(`commercial/invoice/upload/${invoiceId}`, data),
  uploadInvoice2: (data: FormData) => api.post(`commercial/invoice/upload`, data),

  getAllCommissions: () => api.get(StaticGetEndpoints.CurrentCommissions),
  getAllCommissionsByMonth: ({ month, year }: UseCommissionsByMonthQueryParams) =>
    api.get(`commercial/commissions/current/by_month/${month}/${year}`),
  getAllCommissionsInvoices: () => api.get(StaticGetEndpoints.CurrentCommissionsInvoices),
  
  getAllBoostsInvoices: () => api.get(StaticGetEndpoints.CurrentBoostsInvoices),
  getAllBoostsByMonth: ({ month, year }: UseCommissionsByMonthQueryParams) =>
    api.get(`commercial/boosts/current/by_month/${month}/${year}`),
});
